<script setup>
  import {tubePatientTubePosition} from "@pages/Patients/Components/PatientAttributes/Enums.js";

  defineOptions({
    name: "ComponentPatientSidebarTubePatientAttribute",
  });

  defineProps({
    attribute: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <div :class="{'flex flex-wrap space-x-1.5': inline}">
    <h6 class="text-gray-600" :class="{'font-semibold': inline, 'text-xs uppercase': !inline}">
      Sondenpatient{{ inline ? ":" : "" }}
      <slot name="label" />
    </h6>

    <div :class="{'mt-0.5 text-sm': !inline}">
      <slot>
        <span v-if="tubePatientTubePosition[attribute.payload?.tube_position]">
          Endlage im {{ tubePatientTubePosition[attribute.payload?.tube_position] }}.
        </span>
        <span v-else>Der Patient hat eine Sonde.</span>
      </slot>
    </div>
  </div>
</template>
